import React from 'react';
import { FormBlock, FormNumberField, FormTextField } from '../Form';
import { GridDateTimePicker } from '../Form/shared';
import * as datesLocal from '../../helpers/dates';
import styles from './styles';
import {
  AccordionDetails,
  Accordion,
  AccordionSummary,
  Grid2 as Grid,
  FormLabel,
} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { ExpandMore } from '@mui/icons-material';
import moment from 'moment';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

function highlightPanel(delaysServices, ATD, showServices) {
  let highlight =
    (delaysServices?.drinks?.orderedAt == null && showServices.drinks) ||
    (delaysServices?.hotMeals?.orderedAt == null && showServices.hotMeals) ||
    (delaysServices?.hotel?.orderedAt == null &&
      showServices.longDelayServices);

  if (ATD) {
    highlight =
      (delaysServices?.drinks?.finalBillAt == null && showServices.drinks) ||
      (delaysServices?.hotMeals?.finalBillAt == null &&
        showServices.hotMeals) ||
      (delaysServices?.hotel?.finalBillAt == null &&
        showServices.longDelayServices);
  }

  return highlight;
}

function ServicesProvided({ classes, delay, values }) {
  const { ETD, ATD, delaysServices, start } = values.outbound;
  const { t } = useTranslation();
  const delayHours = delay / 3600000;

  const etdDayStart = moment(start).startOf('day');
  const etdDayEvening = etdDayStart.add(22, 'hours');

  const showServices = {
    longDelayServices:
      (delayHours > 8 &&
        moment(ATD !== null ? ATD : ETD).isBefore(etdDayEvening)) ||
      (delayHours > 6 &&
        moment(ATD !== null ? ATD : ETD).isAfter(etdDayEvening)),
    drinks: delayHours > 2,
    hotMeals: delayHours > 4,
  };

  return (
    <Accordion>
      <AccordionSummary
        className={classNames({
          [classes.warning]: highlightPanel(delaysServices, ATD, showServices),
        })}
        expandIcon={<ExpandMore />}
      >
        {t('Delay_checklist_&_services_provided')}
      </AccordionSummary>
      <AccordionDetails className={classes.expansionDetails}>
        {showServices.drinks && (
          <FormBlock variant="contained">
            <Grid size={{ xs: 12, md: 5 }}>
              <FormLabel>{t('Refreshment_Drinks')}</FormLabel>
            </Grid>
            <FormNumberField
              size={4}
              md={2}
              name={`outbound.delaysServices.drinks.amount`}
              label={t('Qty')}
              positiveInteger
            />
            <GridDateTimePicker
              xs={4}
              md={2}
              name={`outbound.delaysServices.drinks.orderedAt`}
              label={t('Start')}
              format={datesLocal.TIME_FORMAT}
            />
            <GridDateTimePicker
              xs={4}
              md={2}
              name={`outbound.delaysServices.drinks.finalBillAt`}
              label={t('End')}
              format={datesLocal.TIME_FORMAT}
            />
          </FormBlock>
        )}

        {showServices.hotMeals && (
          <FormBlock variant="contained">
            <Grid size={{ xs: 12, md: 5 }}>
              <FormLabel>{t('Hot_meals')}</FormLabel>
            </Grid>
            <FormNumberField
              size={4}
              md={2}
              name={`outbound.delaysServices.hotMeals.amount`}
              label={t('Qty')}
              positiveInteger
            />
            <GridDateTimePicker
              xs={4}
              md={2}
              name={`outbound.delaysServices.hotMeals.orderedAt`}
              label={t('Start')}
              format={datesLocal.TIME_FORMAT}
            />
            <GridDateTimePicker
              xs={4}
              md={2}
              name={`outbound.delaysServices.hotMeals.finalBillAt`}
              label={t('End')}
              format={datesLocal.TIME_FORMAT}
            />
          </FormBlock>
        )}

        {showServices.longDelayServices && (
          <>
            <FormBlock variant="contained">
              <Grid size={{ xs: 12, md: 5 }}>
                <FormLabel>{t('Transportation')}</FormLabel>
              </Grid>
              <FormTextField
                size={4}
                md={2}
                name={`outbound.delaysServices.transportation.paxNo`}
                label={t('Pax_No.')}
                positiveInteger
              />
              <GridDateTimePicker
                xs={4}
                md={2}
                name={`outbound.delaysServices.transportation.orderedAt`}
                label={t('Start')}
                format={datesLocal.TIME_FORMAT}
              />
              <GridDateTimePicker
                xs={4}
                md={2}
                name={`outbound.delaysServices.transportation.finalBillAt`}
                label={t('End')}
                format={datesLocal.TIME_FORMAT}
              />
            </FormBlock>
            <FormBlock variant="contained">
              <Grid size={{ xs: 12, md: 5 }}>
                <FormLabel>{t('Hotel_rooms')}</FormLabel>
              </Grid>
              <FormNumberField
                size={3}
                md={2}
                name={`outbound.delaysServices.hotel.amount`}
                label={t('Qty')}
                positiveInteger
              />
              <FormTextField
                size={3}
                md={2}
                name={`outbound.delaysServices.hotel.paxNo`}
                label={t('Pax_No.')}
                positiveInteger
              />
              <GridDateTimePicker
                xs={3}
                md={2}
                name={`outbound.delaysServices.hotel.orderedAt`}
                label={t('Start')}
                format={datesLocal.TIME_FORMAT}
              />
              <GridDateTimePicker
                xs={3}
                md={2}
                name={`outbound.delaysServices.hotel.finalBillAt`}
                label={t('End')}
                format={datesLocal.TIME_FORMAT}
              />
            </FormBlock>
            <FormBlock variant="contained">
              <Grid size={{ xs: 12, md: 5 }}>
                <FormLabel>
                  {t('Additional_meals_provided_at_the_hotel_(if_any)')}
                </FormLabel>
              </Grid>
              <FormNumberField
                size={4}
                md={2}
                name={`outbound.delaysServices.additionalHotMeals.amount`}
                label={t('Qty')}
                positiveInteger
              />
              <GridDateTimePicker
                xs={4}
                md={2}
                name={`outbound.delaysServices.additionalHotMeals.orderedAt`}
                label={t('Start')}
                format={datesLocal.TIME_FORMAT}
              />
              <GridDateTimePicker
                xs={4}
                md={2}
                name={`outbound.delaysServices.additionalHotMeals.finalBillAt`}
                label={t('End')}
                format={datesLocal.TIME_FORMAT}
              />
            </FormBlock>
          </>
        )}
        <FormTextField
          name="outbound.delaysServices.comments"
          label={t('Notes')}
          multiline
          fullWidth
          variant="outlined"
          rows="4"
        />
      </AccordionDetails>
    </Accordion>
  );
}

export default withStyles(styles)(ServicesProvided);
